import React from 'react'
import styled from 'styled-components'
import { motion, AnimatePresence } from 'framer-motion'
import { FaArrowCircleLeft } from 'react-icons/fa'

const Container = styled(motion.div)`
    position: absolute;
    cursor: pointer;
    display: flex;
    top: 50%;
    left: 12%;

    @media all and (max-width: 650px) {
        top: 0;
        left: -10%;
    }
`

const Icon = styled.i`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.5rem;
`

const mainMotion = {
    initial: { opacity: 0, y: 10 },
    animate: { opacity: 1, y: 0, transition: { duration: .3 }},
    exit: { opacity: 0, y: -10}
}

const textMotion = {
    initial: { opacity: 0, y: 10 },
    animate: { opacity: 1, y: 0, transition: { duration: .3 }},
    exit: { opacity: 0, y: -10}
}

const Return = ({ steps, setSteps }) => {
    
    const handleClick = () => {
        setSteps(steps - 1)
    }

    return (
        <Container 
        onClick={handleClick}>
            {
                steps !== 4 &&
                <Icon
                variants={mainMotion}
                initial='initial'
                animate='animate'
                exit='exit'
                >
                    <FaArrowCircleLeft />
                </Icon>
            }
        </Container>
)
}

export default Return